import Vue from 'vue'

Vue.component('SiteSearchResult', {
  template: '#site-search-result',
  props: ['result']
})

